interface ErrorStateProps {
  title?: string
  description?: string
}

export const ErrorState = ({
  title = 'Something went wrong',
  description = 'Please try again later.'
}: ErrorStateProps) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center max-w-md mx-auto p-6">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <p className="text-red-600 text-sm font-medium mb-2">❌ {title}</p>
        <p className="text-red-500 text-xs">{description}</p>
      </div>
    </div>
  </div>
)
